/* eslint-disable react/display-name */
import React from 'react';
import * as Toast from 'react-toast-notifications';

import { UserContext } from 'providers';

export const ToastProvider = ({ children }) => {
  const {
    state: { isLoggedIn },
  } = React.useContext(UserContext);

  return (
    <Toast.ToastProvider
      placement="top-center"
      autoDismiss={true}
      components={{
        ToastContainer: (props) => {
          const className = `react-toast-notifications__container${
            isLoggedIn ? ' with-left-sidebar' : ''
          }`;
          return <Toast.DefaultToastContainer className={className} {...props} />;
        },
      }}
    >
      {children}
    </Toast.ToastProvider>
  );
};
